import { render, staticRenderFns } from "./Turma.vue?vue&type=template&id=1a6cc390&"
import script from "./Turma.vue?vue&type=script&lang=js&"
export * from "./Turma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports